import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getFirestore, provideFirestore } from "@angular/fire/firestore";
import { firebase, firebaseHub } from "../environments/environment.development";
import { getAuth, provideAuth } from "@angular/fire/auth";
import { getRemoteConfig, provideRemoteConfig } from "@angular/fire/remote-config";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { getFunctions, provideFunctions } from "@angular/fire/functions";
import { authInterceptor } from "./services/auth.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),
  provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  provideFirebaseApp(() => initializeApp(firebase)),
  provideFirebaseApp(() => initializeApp(firebaseHub, "hub")),
  provideAnimations(),
  provideFunctions(() => getFunctions()),
  provideFirestore(() => getFirestore()),
  provideAuth(() => getAuth()),
  provideRemoteConfig(() => getRemoteConfig()),
  ],
};
